import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Vendor Management</h3>
                <p className="text-sm text-gray-600">
                    Maintain a directory of service providers, fuel stations, and parts suppliers.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Vendor Profiles</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Click <strong>Add Vendor</strong> to create a new profile.</li>
                    <li>Include <strong>Location</strong> and <strong>Contact Details</strong> to help drivers find approved providers.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Expense Integration</h4>
                <p className="text-sm text-gray-600">
                    Identifying vendors correctly when logging fuel or service expenses allows for detailed spending analysis in the Reports section.
                </p>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Search and Export</h4>
                <p className="text-sm text-gray-600">
                    Quickly find vendor information using the search bar. You can export your entire vendor list to <strong>PDF</strong> or <strong>CSV</strong> for use in third-party accounting software.
                </p>
            </section>
        </div>
    );
};

export default Help;
